import { render, staticRenderFns } from "./ItemsDgTable.vue?vue&type=template&id=9908b02c&"
import script from "./ItemsDgTable.vue?vue&type=script&lang=js&"
export * from "./ItemsDgTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports